/**
 * AccentColorPicker — wybór koloru akcentu strony (przyciski, wyróżnienia).
 * Wartości spójne z ACCENT_PALETTES w PublicBusiness.
 */
import { Check } from 'lucide-react';

const COLORS = [
  { id: 'gold', label: 'Złoty', hex: '#c9a96e' },
  { id: 'blue', label: 'Niebieski', hex: '#6e8ec9' },
  { id: 'green', label: 'Zielony', hex: '#6ec98a' },
  { id: 'red', label: 'Czerwony', hex: '#c96e6e' },
  { id: 'purple', label: 'Fioletowy', hex: '#8e6ec9' },
  { id: 'teal', label: 'Turkusowy', hex: '#6ec9b8' },
  { id: 'pastel-pink', label: 'Pudrowy róż', hex: '#f4b8c1' },
  { id: 'pastel-blue', label: 'Pastelowy błękit', hex: '#a8c8e8' },
  { id: 'pastel-mint', label: 'Mięta', hex: '#a8dbc5' },
  { id: 'pastel-lavender', label: 'Lawenda', hex: '#c5b8d9' },
  { id: 'pastel-peach', label: 'Brzoskwinia', hex: '#f4c9a8' },
  { id: 'pastel-yellow', label: 'Żółty', hex: '#f0e0a0' },
];

export default function AccentColorPicker({ value, onChange }) {
  const active = value || 'gold';
  return (
    <div data-testid="accent-color-picker" className="rounded-2xl border border-gray-200 bg-white p-5">
      <div className="mb-3">
        <p className="text-sm font-semibold text-gray-900">Kolor akcentu</p>
        <p className="text-xs text-gray-500 mt-0.5">Kolor przycisków i wyróżnień na Twojej stronie.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {COLORS.map((c) => {
          const isActive = active === c.id;
          return (
            <button
              key={c.id}
              type="button"
              title={c.label}
              aria-label={c.label}
              data-testid={`accent-${c.id}`}
              onClick={() => onChange?.(c.id)}
              className={`relative w-8 h-8 rounded-full border transition-transform ${isActive ? 'ring-2 ring-offset-2 ring-amber-500 border-white' : 'border-black/10 hover:scale-110'}`}
              style={{ background: c.hex }}
            >
              {isActive && <Check className="w-4 h-4 text-white absolute inset-0 m-auto drop-shadow" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
